import React from 'react'

const SbpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 13 16" width="16" height="16">
    <path fill="#535EAF" d="m.008 3.479 1.945 3.467v2.108L.008 12.51V3.479Z" />
    <path fill="#FF105D" d="m7.462 5.688 1.81-1.11 3.721-.012-5.531 3.388V5.688Z" />
    <path fill="#FFB610" d="m7.451 3.467.011 4.578-1.945-1.19V0L7.45 3.467Z" />
    <path fill="#FF772A" d="m12.993 4.566-3.721.012-1.82-1.11L5.516 0l7.476 4.566Z" />
    <path fill="#00BD37" d="M7.462 12.533v-2.221L5.517 9.133V16l1.945-3.467Z" />
    <path fill="#008BCF" d="M9.272 11.433 1.953 6.946.008 3.48l12.974 7.943-3.71.011Z" />
    <path fill="#00853A" d="m5.517 16 1.945-3.467 1.81-1.1 3.71-.011L5.517 16Z" />
    <path fill="#A54FA4" d="m.008 12.51 5.52-3.377L3.673 8l-1.72 1.054L.008 12.51Z" />
  </svg>
)

export default SbpIcon
